import { Dialog, DialogTitle, DialogHeader, DialogContent, DialogDescription } from '@/components/ui/dialog'
import { useEffect, useState } from 'react'
// import bwipjs from '@bwip-js/browser'
import { useI18n } from '@/i18n/i18n-react'

interface PickupCodeProps {
	title: string
	isOpen: boolean
	onClose: () => void
	orderId: string
	tenant: string
}

export function PickupCodeComponent({ title, isOpen, onClose, orderId, tenant }: PickupCodeProps) {
	const { L } = useI18n()
	const canvasId = 'pickup-code'

	const handleClose = () => {
		onClose()
	}

	const [canvasRef, setCanvasRef] = useState<HTMLCanvasElement | null>(null)

	// useEffect(() => {
	// 	if (!canvasRef) {
	// 		return
	// 	}

	// 	try {
	// 		bwipjs.toCanvas(canvasId, {
	// 				  bcid:        'qrcode',       // Barcode type
	// 				  text:        `fast-track://order?orderId=${orderId}&tenant=${tenant}`,    // Text to encode
	// 				  scale:       4,               // 3x scaling factor
	// 				  height:      10,              // Bar height, in millimeters
	// 				  includetext: true,            // Show human-readable text
	// 				  textxalign:  'center',        // Always good to set this
	// 			  });
	// 	  } catch (e) {
	// 		  console.error('Failed to generate pickup code', e)
	// 	  }

	// 	  return () => {
	// 		const canvas = document.getElementById(canvasId)
	// 		if (canvas) {
	// 			canvas.parentNode?.removeChild(canvas)
	// 		}
	// 	  }

	// }, [canvasRef, orderId, tenant])

	return (
		<Dialog open={isOpen} onOpenChange={handleClose}>
			<DialogContent className='max-w-md'>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<DialogDescription>{L.Receipt.PickupCodeMessage()}</DialogDescription>
				<div className='flex min-h-[250px] justify-center'>
					<canvas ref={el => setCanvasRef(el)} className='aspect-square p-6' id={canvasId}></canvas>
				</div>
			</DialogContent>
		</Dialog>
	)
}
